import type { ReactNode } from "react";

import { cn } from "@/lib/helpers/cn";

export function PatientData({
  children,
  className,
  classNameChildren,
  label,
}: {
  children: ReactNode;
  className?: string;
  classNameChildren?: string;
  label: string;
}) {
  return (
    <div className={cn("tw:text-sm", className)}>
      <dt className="tw:mr-ch tw:inline tw:font-bold tw:whitespace-nowrap">{label}:</dt>
      <dd className={cn("tw:inline", classNameChildren)}>{children}</dd>
    </div>
  );
}
